import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * Resolves the structured Pipeline guide content from the i18n message tree.
 *
 * Shared by PipelinesIndex and PipelineBoard so the "How to use" slide-over
 * shows identical content in both places without duplicating the mapping.
 *
 * `tm` returns compiled message nodes; `rt` renders each leaf to a string.
 *
 * @returns {import('vue').ComputedRef<object>} Content for <FeatureGuide>.
 */
// Os corpos de request (JSON) ficam em JS, NUNCA no i18n: o vue-i18n trata `{...}`
// como placeholder de interpolação e falha ao compilar a mensagem (quebrava o guia).
// A ordem espelha EXATAMENTE PIPELINES.GUIDE.API por índice ('' = endpoint sem corpo, ex.: GET).
const API_BODIES = [
  '{"pipeline":{"name":"Sales","description":"","is_default":true}}',
  '{"pipeline":{"name":"Sales","description":"Comercial","is_default":true,"webhook_url":"https://hooks.example.com/x"}}',
  '{"pipeline_stage":{"name":"Negotiating","label_ids":[1,2]}}',
  '{"pipeline_stage":{"name":"Won","behavior":"won","probability":100,"label_ids":[3]}}',
  '',
  '',
  '',
  '{"conversation_id":10,"from_stage_id":3,"to_stage_id":4}',
  '',
  '{"conversation_id":10,"value":2500}',
  '{"stage_ids":[3,1,2]}',
];

export const usePipelineGuide = () => {
  const { t, tm, rt } = useI18n();

  return computed(() => ({
    overviewTitle: t('GUIDE.COMMON.OVERVIEW_TAB'),
    stepsTitle: t('GUIDE.COMMON.STEPS_TAB'),
    apiTitle: t('GUIDE.COMMON.API_TAB'),
    apiAuth: t('GUIDE.COMMON.API_AUTH'),
    apiTokenHint: t('GUIDE.COMMON.API_TOKEN_HINT'),
    overview: t('PIPELINES.GUIDE.OVERVIEW'),
    useCases: tm('PIPELINES.GUIDE.USE_CASES').map(useCase => ({
      icon: rt(useCase.ICON),
      title: rt(useCase.TITLE),
      description: rt(useCase.DESCRIPTION),
    })),
    steps: tm('PIPELINES.GUIDE.STEPS').map(step => rt(step)),
    api: tm('PIPELINES.GUIDE.API').map((endpoint, index) => ({
      title: rt(endpoint.TITLE),
      url: rt(endpoint.URL),
      body: API_BODIES[index] || '',
    })),
  }));
};
